// components/ProtectedRoute.js
import React from "react";
import { Route, Navigate, useLocation  } from "react-router-dom";
import useAuth from "./useAuth";

const ProtectedRoute = ({ element: Component, requiredRole, ...rest }) => {
    const { user, loading, error } = useAuth();
     const location = useLocation(); // Captura a rota atual
    // console.log(error,'error')
    if (loading) return <div>Loading...</div>; // Você pode substituir por um componente de carregamento
    if (error) return <Navigate to="/login" state={{ from: location }} />; // Redireciona para login se houver erro

    if (user && (!requiredRole || user.profile === requiredRole)) {
        return <Component {...rest} />; // Renderiza o componente se o usuário estiver autenticado e autorizado
    }

    return <Navigate to="/login" state={{ from: location }} replace />;
};

export default ProtectedRoute;
